import BaseApi from './BaseApi'

export default class Contacts extends BaseApi {
  fetchContacts () {
    return this.http.get('/contacts')
  }
}
